// Environment variable helper for Vite migration
// This provides backward compatibility during the transition from CRA to Vite

export const env = {
  API_ENDPOINT_URL: import.meta.env.VITE_API_ENDPOINT_URL || import.meta.env.VITE_API_URL,
  API_ENDPOINT_KEY: import.meta.env.VITE_API_ENDPOINT_KEY || import.meta.env.VITE_API_KEY,
  DRIVER_PUBLIC_API_ENDPOINT_URL: import.meta.env.VITE_DRIVER_PUBLIC_API_ENDPOINT_URL
    || import.meta.env.VITE_API_ENDPOINT_URL
    || import.meta.env.VITE_API_URL,
  IMAGE_ENDPOINT_URL: import.meta.env.VITE_IMAGE_ENDPOINT_URL || import.meta.env.VITE_UPLOAD_URL,
  IMAGE_ENDPOINT_KEY: import.meta.env.VITE_IMAGE_ENDPOINT_KEY || import.meta.env.VITE_UPLOAD_API_KEY,
  STAFF_DOMAIN: import.meta.env.VITE_STAFF_DOMAIN,
  CLIENT_DOMAIN: import.meta.env.VITE_CLIENT_DOMAIN,
  GOOGLE_MAPS_API_KEY:
    import.meta.env.VITE_GOOGLE_MAP_API_KEY || import.meta.env.VITE_GOOGLE_API_KEY,
  GEMINI_API_KEY: import.meta.env.VITE_GEMINI_API_KEY
};
